<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Şirket Oluştur</h4>
              <p class="card-category">Ticaret yaptığınız şirketi oluşturun.</p>



              <form class="m-5">
                <div class="row">
                  <div class="col-md-8">
                    <base-input type="text" label="Şirket Adı (Başlık)" placeholder="Şirket Adı" v-model="payload.title">
                    </base-input>
                  </div>


                  <div class="col-md-4">
                    <base-input type="text" label="Vergi Numarası" placeholder="Vergi Numarası"
                      v-model="payload.identityNumber">
                    </base-input>
                  </div>

                </div>

                <div class="row">
                  <div class="col-md-3">
                    <base-input type="text" label="Ülke" placeholder="Ülke" v-model="payload.country">
                    </base-input>
                  </div>
                  <div class="col-md-3">
                    <base-input type="text" label="Şehir" placeholder="Şehir" v-model="payload.city">
                    </base-input>
                  </div>
                  <div class="col-md-6">
                    <base-input type="text" label="Adres" placeholder="Adres" v-model="payload.address">
                    </base-input>
                  </div>
                </div>





                <div class="row">
                  <div class="col-md-12">
                    <label>Şirket Kontakları</label>
                    <div v-for="(contact, index) in payload.contactList" :key="index" class="d-flex mb-2">
                      <input type="text" class="form-control mr-2" v-model="contact.name" placeholder="İsim">
                      <input type="text" class="form-control mr-2" v-model="contact.email" placeholder="Email">
                      <input type="text" class="form-control mr-2" v-model="contact.phone" placeholder="Telefon">
                      <button class="btn btn-danger btn-sm btn-fill" @click="removeContact(index)">Sil</button>
                    </div>
                    <div class="mt-2">

                      <button class="btn btn-sm btn-primary" @click="addContact()">Yeni Kontak Ekle</button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label>Şirket Web Adresleri</label>
                    <div v-for="(domain, index) in payload.companyDomainList" :key="index" class="d-flex mb-2">
                      <input type="text" class="form-control mr-2" v-model="payload.companyDomainList[index]"
                        placeholder="www.orneksirket.com">
                      <button class="btn btn-danger btn-sm btn-fill" @click="removeDomain(index)">Sil</button>
                    </div>
                    <div class="mt-2">

                      <button class="btn btn-sm btn-primary" @click="addDomain()">Yeni Domain Ekle</button>
                    </div>
                  </div>
                </div>


                <div class="row pt-5">
                  <div class="col-md-12">
                    <label>Aktif Mi?</label>
                    <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="payload.isActive"
                      :checked="payload.isActive" @click="payload.isActive = !payload.isActive">
                    </base-checkbox>
                  </div>
                </div>






                <div class="text-center pt-5">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewCompany()">
                    Oluştur
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>

            </template>
          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      payload: {
        title: "",
        country: "",
        city: "",
        address: "",
        identityNumber: "",
        companyDomainList: [],
        contactList: [],
        isActive: true
      },
      currencies: [{
        _id: "EUR",
        name: "Euro"
      }, {
        _id: "USD",
        name: "Dolar"
      }, {
        _id: "TRY",
        name: "Türk Lirası"
      }
      ],
      statusMap: [
        {
          _id: "active",
          name: "Listede"
        },
        {
          _id: "inactive",
          name: "Pasif"
        },
        {
          _id: "sold",
          name: "Satıldı"
        },
        {
          _id: "pending",
          name: "Beklemede"
        },
        {
          _id: "rented",
          name: "Kiralandı"
        },
        {
          _id: "maintenance",
          name: "Tamirde"
        },
        {
          _id: "other",
          name: "Diğer"
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    createNewCompany() {
      CollectionService.postWidthAuth('company', this.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Şirket Oluşturuldu")
          this.$router.push(`/admin/companies`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    addContact() {
      this.payload.contactList.push({
        name: "",
        email: "",
        phone: ""
      })
    },
    removeContact(index) {
      this.payload.contactList.splice(index, 1);
    },
    addDomain() {
      this.payload.companyDomainList.push("")
    },
    removeDomain(index) {
      this.payload.companyDomainList.splice(index, 1);
    }
  }
}
</script>
<style></style>